<template>
  <div class="pageContol listWrap templateList">
    <div class="framePage">
      <div class="framePage-title">
        <span>
          <em>当前位置：</em>
          <a href="javascript:;">单位管理</a>
          <i>></i>
          <a href="javascript:;" @click="init" class="cur-a">企业单位列表</a>
        </span>
      </div>
      <div class="framePage-body">
        <div class="operationControl flexdc" style="align-items: flex-start">
          <div class="searchbox" style="margin-bottom: 5px">
            <div title="单位名称" class="searchboxItem ci-full">
              <span class="itemLabel">单位名称:</span>
              <el-input v-model="unitname" type="text" size="small" class="unitNamewidth" placeholder="请输入单位名称"
                clearable />
            </div>
            <div title="行政区划" class="searchboxItem ci-full">
              <span class="itemLabel">行政区划:</span>
              <el-cascader clearable filterable v-model="areaId" :options="areatreeList" :props="propsarea"
                size="small"></el-cascader>
            </div>
            <div title="联系人电话" class="searchboxItem ci-full">
              <span class="itemLabel" style="min-width: 6rem">联系人电话:</span>
              <el-input v-model="compPhone" type="text" size="small" placeholder="请输入联系人电话" clearable />
            </div>
            <div title="法人姓名" class="searchboxItem ci-full">
              <span class="itemLabel">法人姓名:</span>
              <el-input v-model="compName" type="text" size="small" placeholder="请输入法人姓名" clearable />
            </div>
          </div>
          <div class="searchbox" style="margin-bottom: 5px">
            <div title="单位类型" class="searchboxItem ci-full">
              <span class="itemLabel">单位类型:</span>
              <el-select v-model="compType" placeholder="请选择" size="small" clearable>
                <el-option v-for="item in companyList" :key="item.value" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </div>
            <div title="信用代码" class="searchboxItem ci-full">
              <span class="itemLabel">信用代码:</span>
              <el-input v-model="compNo" type="text" size="small" placeholder="请输入信用代码" clearable />
            </div>
            <div title="市场负责人" class="searchboxItem ci-full">
              <span class="itemLabel" style="min-width: 6rem">市场负责人:</span>
              <el-select v-model="marketId" placeholder="请选择" size="small" clearable @change="
                (val) => {
                  clean(val, 'saleName');
                }
              ">
                <el-option v-for="item in marketLeaderList" :key="item.saleId" :label="item.saleName"
                  :value="item.saleId"></el-option>
              </el-select>
            </div>
            <div title="上级单位" class="searchboxItem ci-full">
              <span class="itemLabel">上级单位:</span>
              <el-select size="small" v-model="superiorCompId" remote :remote-method="getCompSourceList" filterable
                clearable placeholder="请输入两个字搜索">
                <el-option v-for="item in compSourceList" :key="item.compId" :label="item.compName"
                  :value="item.compId"></el-option>
              </el-select>
            </div>
          </div>
          <div class="searchbox">
            <div title="入驻时间" class="searchboxItem ci-full">
              <span class="itemLabel">入驻时间:</span>
              <el-date-picker clearable size="small" v-model="entryTime" type="daterange" range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </div>
            <div class="btnBox">
              <el-button class="bgc-bv" round @click="getData()">查询</el-button>
              <el-button class="bgc-bv" round @click="add()">新增</el-button>
              <el-button class="bgc-bv" round @click="BatchImport()">批量导入</el-button>
            </div>
          </div>
        </div>
        <div class="framePage-scroll">
          <div class="ovy-a">
            <el-table ref="multipleTable" :data="tableData" :height="tableHeight" size="small" tooltip-effect="dark"
              style="width: 100%" :header-cell-style="tableHeader" stripe>
              <el-table-column label="序号" align="center" type="index" :index="indexMethod" width="80" />
              <el-table-column label="单位名称" align="left" prop="compName" show-overflow-tooltip min-width="200" />
              <el-table-column label="单位类型" align="left" prop="compType" show-overflow-tooltip min-width="80">
                <template slot-scope="{row}">
                  {{ $setDictionary('COMPANYTYPE', row.compType) }}
                </template>
              </el-table-column>
              <el-table-column label="信用代码" align="left" prop="compNo" show-overflow-tooltip min-width="120" />
              <el-table-column label="上级单位" align="left" prop="compParentName" show-overflow-tooltip min-width="180">
                <template slot-scope="scope">
                  {{ scope.row.compParentName || "--" }}
                </template>
              </el-table-column>
              <el-table-column label="所属行政区划" align="left" prop="areaNamePath" show-overflow-tooltip min-width="150" />
              <el-table-column label="联系人电话" align="left" prop="compPhone" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ scope.row.compPhone || "--" }}
                </template>
              </el-table-column>
              <el-table-column label="法人姓名" align="left" prop="compLegal" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ scope.row.compLegal || "--" }}
                </template>
              </el-table-column>
              <el-table-column label="市场负责人" align="left" prop="marketName" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ scope.row.marketName || "--" }}
                </template>
              </el-table-column>
              <el-table-column label="入驻时间" align="left" prop="createTime" show-overflow-tooltip width="100px">
                <template slot-scope="scope">
                  {{ scope.row.createTime | momentDate }}
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="220px">
                <div slot-scope="scope" class="flexcc">
                  <el-button type="text" style="padding: 0px 5px" size="mini"
                    @click="handleEdit(scope.row.compId)">编辑</el-button>
                  <el-button type="text" style="padding: 0px 5px" size="mini"
                    @click="handleAdd(scope.row.compId)">新增</el-button>
                  <el-button type="text" style="padding: 0px 5px" size="mini"
                    @click="GenerateQRcode(scope.row)">生成二维码</el-button>
                  <el-button type="text" style="padding: 0px 5px" size="mini"
                    @click="zUnbind(scope.row)">解除绑定</el-button>
                </div>
              </el-table-column>
              <Empty slot="empty" />
            </el-table>
          </div>
        </div>
        <PageNum :apiData="apiData" @sizeChange="sizeChange" @getData="getData" />
      </div>
    </div>
    <el-dialog title="生成二维码" :visible="generateQRcodeImgLoading" :before-close="doClose" width="500px">
      <div ref="pic_content">
        <img style="width: 100%" :src="generateQRcodeImg" alt="" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="generateQRcodeImgLoading = false" size="small">关 闭</el-button>
        <!-- <el-button
          class="bgc-bv"
          @click="downloadGenerateQRcode(generateQRcodeImg,'6666')"
          size="small"
          >下 载</el-button
        > -->
      </span>
    </el-dialog>
    <!-- 鉴定机构通用导入 -->
    <!-- businessType  导入业务类型标识 [ BUSINESS_TYPE ]-->
    <!-- importType  导入类型 学员-->
    <!-- unit  单位 学员-人-->
    <!--fileType  EXCEL  ZIP-->
    <accreditationAgencyImport ref="accreditationAgencyImport" @eventBus="accreditationAgencyImportBack"
      businessType="ANZHI_COMPANY_ASYNC_IMPORT" :batchImportData="batchImportData" importType="学员" unit="人"
      fileType="EXCEL">
      <template v-slot:header>
        <el-form class="import_template_slot" size="small" label-width="80px">
          <el-form-item class="w_300" label="行政区划" required>
            <el-cascader clearable filterable v-model="batchImportData.otherParams" :options="areatreeList"
              :props="propsarea" size="small"></el-cascader>
          </el-form-item>
        </el-form>
      </template>
    </accreditationAgencyImport>
  </div>
</template>
<script>
import Empty from "@/components/Empty.vue";
import PageNum from "@/components/PageNum.vue";
import List from "@/mixins/List";
import { resetKeepAlive } from "@/utils/common";
import accreditationAgencyImport from "@/components/accreditationAgencyImport.vue";
export default {
  name: "UnitList",
  components: {
    Empty,
    PageNum,
    accreditationAgencyImport,
  },
  mixins: [List],
  data() {
    return {
      // 行政区划 - 下拉数据
      areatreeList: [],
      // 行政区划 - 规定字段
      propsarea: {
        value: "value",
        label: "label",
        emitPath: false,
        checkStrictly: true,
      },
      // 单位类型 - 下拉数据
      companyList: [],
      // 上级单位 - 下拉数据
      compSourceList: [],
      compType: "",
      areaId: "",
      unitname: "",
      compPhone: "",
      compName: "",
      superiorCompId: "",
      compNo: "",
      entryTime: [], //入驻时间,
      marketId: "",
      search: {
        saleName: true,
      },
      // 生成二维码的 - loading
      generateQRcodeImgLoading: false,
      // 生成的二维码
      generateQRcodeImg: "",
      // 批量导入 - 数据集合
      batchImportData: {
        areaId: "", // 行政区划
      },
    };
  },
  created() {
    this.getCompSourceList();
    this.getareatree();
    this.getcompanyList();
    this.getMarketLeader();

    // this.getTemplate(this.projectId);
  },
  computed: {},
  methods: {
    // 行政区划 - 下拉数据
    getareatree() {
      this.$post("/sys/area/tree").then((ret) => {
        this.areatreeList = ret.data;
      });
    },
    // 单位类型 - 下拉数据
    getcompanyList() {
      const companyList = this.$setDictionary("COMPANYTYPE", "list");
      let companylist = [{ value: "", label: "全部" }];
      for (const key in companyList) {
        companylist.push({
          value: key,
          label: companyList[key],
        });
      }
      this.companyList = companylist;
    },
    //获取市场负责人
    getMarketLeader(saleType) {
      this.$post("/biz/user/sale/selectList", { saleType: "10" }).then(
        (ret) => {
          this.marketLeaderList = ret.data || [];
        }
      );
    },
    // 上级单位
    getCompSourceList(query) {
      if (query && query.trim().length >= 2) {
        this.$post("/sys/company/queryCompanyList", { compName: query })
          .then((res) => {
            if (res.status == 0) {
              this.compSourceList = res.data || [];
            }
          })
          .catch(() => {
            return;
          });
      } else {
        this.companyList = [];
      }
    },
    // 选择市场负责人
    clean(val, name) {
      this[name] = val;
      this.search[name] = false;
    },
    // 新增
    add() {
      this.$router.push({
        path: "/web/UnitEdit",
        query: { stu: "add" },
      });
    },
    // 列表的新增
    handleAdd(compId) {
      this.$router.push({
        path: "/web/UnitEdit",
        query: { compId, stu: "addsubordinate" },
      });
    },
    // 初始化获取列表
    getData(pageNum = 1) {
      if (this.search.saleName) {
        this.marketId = this.$route.query.saleId;
      }
      const params = {
        pageNum: pageNum,
        pageSize: this.pageSize,
      };
      if (this.unitname) {
        params.compName = this.unitname;
      }
      if (this.areaId) {
        params.areaId = this.areaId;
      }
      if (this.compType) {
        params.compType = this.compType;
      }
      if (this.compPhone) {
        params.compPhone = this.compPhone;
      }
      if (this.compName) {
        params.compLegal = this.compName;
      }
      if (this.marketId) {
        params.marketId = this.marketId;
      }
      if (this.superiorCompId) {
        params.superiorCompId = this.superiorCompId;
      }
      if (this.compNo) {
        params.compNo = this.compNo;
      }

      if (this.entryTime) {
        params.startDate = this.entryTime[0];
        params.endDate = this.entryTime[1];
      }
      this.doFetch({
        url: "/sys/company/page-list",
        params,
        pageNum,
      });
    },
    // 单位编辑
    handleEdit(compId) {
      this.$router.push({
        path: "/web/UnitEdit",
        query: { compId, stu: "edit" },
      });
    },
    // 生成二维码
    GenerateQRcode(row) {
      this.$post("biz/subscribeProject/createSubscribeCompanyQRCode", {
        compId: row.compId,
      }).then((res) => {
        this.generateQRcodeImgLoading = true;
        this.generateQRcodeImg = res.data;
      });
    },
    // 下载生成二维码
    downloadGenerateQRcode(imgsrc, name) {
      this.$message({
        message: "此功能暂时延期，请别提bug",
        type: "warning",
      });
      // let image = new Image();
      // // 解决跨域 Canvas 污染问题
      // image.setAttribute("crossOrigin", "anonymous");
      // image.onload = function() {
      //   let canvas = document.createElement("canvas");
      //   canvas.width = image.width;
      //   canvas.height = image.height;
      //   let context = canvas.getContext("2d");
      //   context.drawImage(image, 0, 0, image.width, image.height);
      //   let url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
      //   let a = document.createElement("a"); // 生成一个a元素
      //   let event = new MouseEvent("click"); // 创建一个单击事件
      //   a.download = name || "photo"; // 设置图片名称
      //   a.href = url; // 将生成的URL设置为a.href属性
      //   a.dispatchEvent(event); // 触发a的单击事件
      // };
      // image.src = imgsrc;

      // const fileName= `${name}.png`;
      // const myBlob = new Blob([imgsrc], { type: "image/png" });
      // const link = document.createElement("a");
      // link.href = URL.createObjectURL(myBlob);
      // link.download = fileName;
      // link.click();
      // link.remove();
      // URL.revokeObjectURL(link.href);

      // let link = document.createElement("a");
      // link.style.display = "none";
      // link.href = "https://p5.toutiaoimg.com/origin/pgc-image/SNISfitBmdzyEz?from=pc.png";
      // link.setAttribute("download", "push_temp.png");
      // document.body.appendChild(link);
      // link.click();
      // document.body.removeChild(link);
      // this.generateQRcodeImgLoading = false;
      // this.downloadIamge('https://p5.toutiaoimg.com/origin/pgc-image/SNISfitBmdzyEz?from=pc.png')
    },
    // 关闭生成二维码
    doClose(done) {
      this.generateQRcodeImgLoading = false;
    },
    // 解除绑定
    zUnbind(row) {
      this.$router.push({
        path: "/web/zUnbind",
        query: { compId: row.compId },
      });
    },
    getTableHeight(opDom = true, page = true) {
      let tHeight =
        window.innerHeight - (3 + 1.35 + 3.25 + 0.675 + 2 + 1.35 + 1.35) * 16;
      if (opDom) {
        tHeight -= 40 + 0.675 * 16 + 1 + 40;
      }
      if (page) {
        tHeight -= 25;
      }
      this.tableHeight = tHeight;
    },
    // 批量导入 - 打开组件
    BatchImport() {
      this.$refs.accreditationAgencyImport.showPopup('0');
    },
    // 批量导入 - 关闭
    accreditationAgencyImportBack() {
      this.batchImportData = this.$options.data().batchImportData;
      this.getData(-1);
    },
  },
  beforeRouteLeave: resetKeepAlive,
  watch: {
    $route: {
      handler: function (val, oldVal) {
        if (val.query.refresh) {
          this.getData(-1);
        }
        if (oldVal.query.stu == "add") {
          (this.unitname = ""),
            (this.areaId = ""),
            (this.compType = ""),
            (this.compPhone = ""),
            (this.compName = ""),
            (this.pageNum = 1);
          this.getData(-1);
        }
      },
      // 深度观察监听
      deep: true,
    },
  },
};
</script>
<style lang="less" scoped>
.upload-btn {
  height: 40px;

  .el-upload {
    height: 40px !important;
    border: none !important;
  }
}

.searchbox {
  padding: 0;
}

.el-button.is-disabled,
.el-button.is-disabled:focus,
.el-button.is-disabled:hover {
  background-color: transparent;
}

.confirmButtonClass {
  color: #fff !important;
  background-color: #5c6be8 !important;
  border-color: #5c6be8 !important;
}

.btnBox {
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}

.exportdialog {
  .el-dialog__title {
    font-size: 16px;
  }

  .export-box {
    width: 100%;
    margin-bottom: 20px;

    h1 {
      padding: 0 5px 10px;
      display: flex;
      align-items: flex-end;
      font-size: 40px;
      border-bottom: 1px dashed #ccc;

      span {
        margin-left: 20px;
        font-size: 14px;
      }
    }

    >div {
      padding-left: 30px;
    }

    .el-button.is-disabled,
    .el-button.is-disabled:focus,
    .el-button.is-disabled:hover {
      color: #fff;
      background: #c3c3c3;
      border: none;
    }
  }
}

.docsDialog {
  .el-form-item {
    margin-bottom: 0.5rem;
  }
}

/deep/ .upload-workers {
  height: 30px;

  .el-upload {
    height: 30px !important;
    width: 97px;
    border: none !important;

    .el-button {
      padding: 5px 0;
    }
  }
}

.studentNum {
  margin: 0 0 10px;

  span {
    margin: 0 10px;
  }
}

// 导入模板 - 插槽 - 样式
.import_template_slot {
  padding-top: 20px;

  .w_300 {
    width: 300px;
  }
}
</style>